import { useContext } from "react";
import type { ExperimentState } from "@hopper-b2b/types";
import { ExperimentsContext } from "../ExperimentsProvider";

export const useExperiments = (): ExperimentState => {
  const ctx = useContext(ExperimentsContext);
  if (!ctx) throw new Error(`must be used within a ExperimentsProvider`);
  return ctx;
};
